/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Filter_AllInputs */

const en_directory_launch_filter_all = /** @type {(inputs: Directory_Launch_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All categories`)
};

const zh_directory_launch_filter_all = /** @type {(inputs: Directory_Launch_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部分类`)
};

/**
* | output |
* | --- |
* | "All categories" |
*
* @param {Directory_Launch_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_filter_all = /** @type {((inputs?: Directory_Launch_Filter_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Filter_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_filter_all(inputs)
	return zh_directory_launch_filter_all(inputs)
});
export { directory_launch_filter_all as "directory.launch.filter_all" }